import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ps-panel" }
const _hoisted_2 = {
  key: 0,
  class: "ps-security-prompt"
}
const _hoisted_3 = {
  key: 1,
  class: "ps-field-group"
}
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = {
  key: 0,
  class: "ps-error"
}
const _hoisted_8 = { class: "ps-panel-ft" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "ps-panel-hd" }, [
      _createElementVNode("h2", null, "Segurança"),
      _createElementVNode("p", null, "Altere sua senha de acesso ao sistema.")
    ], -1)),
    (!_ctx.changingPassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5",
            opacity: ".3"
          }, [
            _createElementVNode("rect", {
              x: "6",
              y: "14",
              width: "20",
              height: "14",
              rx: "3"
            }),
            _createElementVNode("path", {
              d: "M10 14v-4a6 6 0 0 1 12 0v4",
              "stroke-linecap": "round"
            }),
            _createElementVNode("circle", {
              cx: "16",
              cy: "21",
              r: "2",
              fill: "currentColor",
              stroke: "none"
            })
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "Sua senha está protegida. Clique em \"Alterar senha\" para defini-la.", -1)),
          _createElementVNode("button", {
            class: "btn btn-ghost btn-login",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openChangePassword && _ctx.openChangePassword(...args)))
          }, "Alterar senha")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "seg-curpw" }, "Senha atual", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "seg-curpw",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPasswordInput) = $event)),
              type: "password"
            }, null, 512), [
              [_vModelText, _ctx.currentPasswordInput]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "seg-newpw" }, "Nova senha", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "seg-newpw",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newPassword) = $event)),
              type: "password"
            }, null, 512), [
              [_vModelText, _ctx.newPassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "seg-confpw" }, "Confirmar nova senha", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "seg-confpw",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmNewPassword) = $event)),
              type: "password"
            }, null, 512), [
              [_vModelText, _ctx.confirmNewPassword]
            ])
          ]),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-login",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
            }, "Alterar senha"),
            _createElementVNode("button", {
              class: "btn btn-ghost btn-login",
              type: "button",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelChangePassword && _ctx.cancelChangePassword(...args)))
            }, "Cancelar")
          ])
        ]))
  ]))
}